import { Accordion, AccordionDetails, AccordionSummary, alpha, Box, Chip, Typography } from '@mui/material';
import { ChevronDownIcon } from '../../assets/icons';
import { AppIcon } from '../app-icon/AppIcon';
import { EligibilityContent } from './types';
import { eligibilityFailContentStyles } from './styles';
import { EligibilityFailCriteriaList } from './EligibilityFailCriteriaList';

interface EligibilityFailAccordionItemProps {
  eligibilityContent: EligibilityContent;
}
export const EligibilityFailAccordionItem: React.FC<EligibilityFailAccordionItemProps> = ({ eligibilityContent }) => {
  return (
    <Accordion defaultExpanded sx={eligibilityFailContentStyles.accordion}>
      <AccordionSummary
        sx={eligibilityFailContentStyles.accordionSummary}
        expandIcon={<AppIcon sx={{ fontSize: '1rem' }} Icon={ChevronDownIcon} />}
        id={`eligibility-fail-${eligibilityContent.id}-item`}
        aria-controls={`eligibility-fail-${eligibilityContent.id}-item-content`}
      >
        <Typography sx={{ ml: 1.5 }} fontWeight="Bold">
          {eligibilityContent.title}
        </Typography>
        {eligibilityContent.includeTag && (
          <Chip
            color={eligibilityContent.isEligible ? 'success' : 'error'}
            label={eligibilityContent.isEligible ? 'Eligible' : 'Ineligible'}
            sx={{ color: 'common.white' }}
          />
        )}
      </AccordionSummary>
      <AccordionDetails sx={eligibilityFailContentStyles.accordionDetail}>
        <Box sx={eligibilityFailContentStyles.resultList}>
          {eligibilityContent.results ? (
            eligibilityContent.results.map((result, index) => (
              <Box key={index}>
                {result.title && (
                  <Typography
                    fontWeight="Bold"
                    sx={{ py: 1, px: 3, bgcolor: (theme) => alpha(theme.palette.grey[100], 0.25) }}
                  >
                    {result.title}
                  </Typography>
                )}
                <EligibilityFailCriteriaList messages={result.messages} />
              </Box>
            ))
          ) : (
            <Typography
              sx={{ px: 3, py: 1.5 }}
              fontWeight="Medium"
              color={eligibilityContent.isEligible ? 'success' : 'error'}
            >
              {eligibilityContent.isEligible
                ? 'There are no requirements required. You are eligible.'
                : 'Requirements could not be found at the moment. You are ineligible. Please try again later.'}
            </Typography>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
